import api from "./client"
import type { Exercise } from "../types"

export async function getExercises(): Promise<Exercise[]> {
  const { data } = await api.get<Exercise[]>("/exercises")
  return data
}

export async function createExercise(params: Record<string, unknown>): Promise<Exercise> {
  const { data } = await api.post<Exercise>("/exercises", { exercise: params })
  return data
}

export async function updateExercise(
  id: number,
  params: Record<string, unknown>,
): Promise<Exercise> {
  const { data } = await api.patch<Exercise>(`/exercises/${id}`, { exercise: params })
  return data
}

export async function deleteExercise(id: number): Promise<void> {
  await api.delete(`/exercises/${id}`)
}
